import request from "@/utils/request";

// 评审会议列表
export function reviewMeetingPageList(data) {
    return request({
        url: "/cloud/application/reviewMeeting/pageList",
        method: "post",
        data: data
    });
}

// 获取评审会议列表
export function getReviewMeetingListByApplicationId(applicationId) {
    return request({
        url: "/cloud/application/reviewMeetings?applicationId=" + applicationId,
        method: "get"
    });
}

// 创建评审会议
export function createReviewMeeting(data) {
    return request({
        url: "/cloud/application/reviewMeeting",
        method: "post",
        data: data
    });
}

// 删除评审会议
export function deleteReviewMeetingById(id) {
    return request({
        url: "/cloud/application/reviewMeeting/deleteById?id=" + id,
        method: "post"
    });
}

// 结束评审会议
export function overReviewMeeting(data) {
    return request({
        url: "/cloud/application/reviewMeeting/over",
        method: "post",
        data: data
    });
}